<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M12.5117 5.69L17.5117 10.19V18H15.5117V12H9.51172V18H7.51172V10.19L12.5117 5.69ZM12.5117 3L2.51172 12H5.51172V20H11.5117V14H13.5117V20H19.5117V12H22.5117"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconHouse",
};
</script>

<style></style>
